import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { DeviceContext } from '../services/Context'
import { MAX_DESCRIPTION_LENGTH } from '../constants'
import { useDispatch } from 'react-redux'
import { Dispatch } from '../store'
import { InlineTextFieldSetting } from './InlineTextFieldSetting'

export const DeviceDescriptionSetting: React.FC = () => {
  const { t } = useTranslation()
  const { devices } = useDispatch<Dispatch>()
  const { device } = useContext(DeviceContext)

  if (!device) return null

  return (
    <InlineTextFieldSetting
      icon="paragraph"
      label={t('deviceDescriptionSetting.label', 'Device Description')}
      value={device.attributes.description}
      disabled={!device.permissions.includes('MANAGE')}
      resetValue={device.attributes.description}
      maxLength={MAX_DESCRIPTION_LENGTH}
      onSave={description => {
        const updated = structuredClone(device)
        updated.attributes = { ...device.attributes, description: description.toString() }
        devices.setAttributes(updated)
      }}
    />
  )
}
